import React, { memo } from "react";
import GlobalLogo from "./GlobalLogo";
import StickyBrianstein from "./StickyBrianstein";
import SidebarRouteNav from "./SidebarRouteNav";

function Sidebar({
    title,
    topOffsetPx = 64,
    links = [],
    children,
    searchSpace,
    childrenFill = false,
    themeMode = "dark",
    onThemeModeChange,
}) {
    const showNav = Boolean(title) || (links && links.length > 0);
    const showBrianstein = searchSpace === "in";

    return (
        <div
            style={{
                width: "300px",
                height: "100%",
                minHeight: 0,
                flexShrink: 0,
                backgroundColor: "var(--app-sidebar-bg)",
                borderRight: "1px solid var(--app-sidebar-border)",
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                paddingTop: `${topOffsetPx}px`,
                boxSizing: "border-box",
                overflow: "hidden",
                transition: "background-color 0.2s ease, border-color 0.2s ease",
            }}
        >
            <div
                style={{
                    width: "100%",
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    overflow: "hidden",
                }}
            >
                <div className="sidebar-brand">
                    <GlobalLogo
                        className="app-global-logo--sidebar"
                        themeMode={themeMode}
                    />
                    {showBrianstein && <StickyBrianstein />}
                </div>

                {children && (
                    <div
                        style={{
                            width: "100%",
                            minWidth: 0,
                            maxWidth: "100%",
                            overflow: "hidden",
                            marginBottom: "12px",
                            display: childrenFill ? "flex" : undefined,
                            flexDirection: childrenFill ? "column" : undefined,
                            flex: childrenFill ? 1 : undefined,
                            minHeight: childrenFill ? 0 : undefined,
                        }}
                    >
                        {children}
                    </div>
                )}

                {showNav && (
                    <div
                        style={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "hidden",
                            minWidth: 0,
                            marginTop: "12px",
                        }}
                    >
                        {title && (
                            <h3
                                style={{
                                    color: "var(--app-sidebar-title)",
                                    fontSize: "18px",
                                    marginBottom: "15px",
                                    borderBottom: "1px solid var(--app-sidebar-border)",
                                    paddingBottom: "10px",
                                    minWidth: 0,
                                    overflowWrap: "break-word",
                                }}
                            >
                                {title}
                            </h3>
                        )}

                        {links.map((link) => (
                            <button
                                key={link.label}
                                onClick={link.onClick}
                                style={{
                                    width: "100%",
                                    minWidth: 0,
                                    textAlign: "left",
                                    background: "transparent",
                                    border: "none",
                                    color: "var(--app-sidebar-text)",
                                    padding: "10px 10px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    transition: "background-color 0.2s ease, color 0.2s ease",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "var(--app-sidebar-nav-hover-bg)";
                                    e.currentTarget.style.color = "var(--app-sidebar-nav-hover-text)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "transparent";
                                    e.currentTarget.style.color = "var(--app-sidebar-text)";
                                }}
                            >
                                {link.label}
                            </button>
                        ))}
                    </div>
                )}

                <SidebarRouteNav
                    searchSpace={searchSpace}
                    themeMode={themeMode}
                    onThemeModeChange={onThemeModeChange}
                />
            </div>
        </div>
    );
}

export default memo(Sidebar);